<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">确认等待修复？</div>
<div class="content" mat-dialog-content>
  <div class="txt0">修复政策说明：</div>
  <div class="txt1">1. 订单状态变更为“正在修复”，时长暂停计算。</div>
  <div class="txt1">2. 修复成功：邮件通知，并自动补偿双倍等待时长。</div>
  <div class="txt1">3. 修复失败：您可选择更换新邮箱加入。</div>
</div>
<div class="button">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="onOk()"
  >
    确认等待，自动创建工单
  </button>
</div>
